const STATS = [
  { val: "1,000+", label: "Page-scale PDFs", sub: "large CIB reports supported", color: "text-violet-300", border: "border-violet-500/30", bg: "bg-violet-500/10" },
  { val: "PyMuPDF", label: "PDF engine", sub: "page-level extraction", color: "text-cyan-300", border: "border-cyan-500/30", bg: "bg-cyan-500/10" },
  { val: "12", label: "Global workers", sub: "configurable processing ceiling", color: "text-purple-300", border: "border-purple-500/30", bg: "bg-purple-500/10" },
  { val: "WAL", label: "SQLite mode", sub: "concurrent-safe audit storage", color: "text-emerald-300", border: "border-emerald-500/30", bg: "bg-emerald-500/10" },
  { val: "3-way", label: "Outcome model", sub: "SUCCESS / REVIEW / FAILED", color: "text-amber-300", border: "border-amber-500/30", bg: "bg-amber-500/10" },
  { val: "Word", label: "Automated reporting", sub: "generated after processing", color: "text-sky-300", border: "border-sky-500/30", bg: "bg-sky-500/10" },
];

const PIPELINE_STEPS = [
  { label: "Ingest", sub: "PDF batch", fill: "rgba(129,140,248,.10)", stroke: "rgba(129,140,248,.4)" },
  { label: "Extract", sub: "PyMuPDF", fill: "rgba(34,211,238,.10)", stroke: "rgba(34,211,238,.4)" },
  { label: "Validate", sub: "CIB rules", fill: "rgba(59,130,246,.10)", stroke: "rgba(59,130,246,.4)" },
  { label: "Reconcile", sub: "Financials", fill: "rgba(168,85,247,.10)", stroke: "rgba(168,85,247,.4)" },
  { label: "Classify", sub: "Outcome", fill: "rgba(245,158,11,.10)", stroke: "rgba(245,158,11,.4)" },
  { label: "Report", sub: "Word + audit", fill: "rgba(34,197,94,.10)", stroke: "rgba(34,197,94,.4)" },
];

export default function ProcessingDashboard() {
  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">PROCESSING OVERVIEW</p>
        <h4 className="mt-1 text-sm font-semibold text-white">CIB PDF processing and reporting pipeline</h4>
        <p className="mt-1 text-xs text-slate-400">
          Turns CIB PDF batches into validated financial results through page-level extraction, reconciliation, controlled review, auditable processing, and automated Word reporting.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {STATS.map(({ val, label, sub, color, border, bg }) => (
          <div key={label} className={`rounded-xl border ${border} ${bg} p-3`}>
            <p className={`text-lg font-bold ${color}`}>{val}</p>
            <p className="mt-0.5 text-xs font-medium text-slate-200">{label}</p>
            <p className="text-[10px] text-slate-500">{sub}</p>
          </div>
        ))}
      </div>

      <div className="overflow-x-auto rounded-xl border border-white/10 bg-black/30 p-4">
        <p className="mb-3 font-mono text-[10px] tracking-[0.18em] text-slate-500">PROCESSING PIPELINE</p>
        <svg viewBox="0 0 700 90" width="100%" style={{ minWidth: 520 }}>
          <defs>
            <marker id="cib-arr" viewBox="0 0 10 10" refX={8} refY={5} markerWidth={5} markerHeight={5} orient="auto-start-reverse">
              <path d="M2 1L8 5L2 9" fill="none" stroke="rgba(255,255,255,.2)" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
            </marker>
          </defs>
          {PIPELINE_STEPS.map((s, i) => {
            const x = 10 + i * 116;
            return (
              <g key={s.label}>
                <rect x={x} y={10} width={100} height={52} rx={7} fill={s.fill} stroke={s.stroke} strokeWidth={0.8} />
                <text x={x + 50} y={33} textAnchor="middle" fontSize={10.5} fontWeight={600} fill="#f0f4ff" fontFamily="system-ui">{s.label}</text>
                <text x={x + 50} y={50} textAnchor="middle" fontSize={9} fill="rgba(255,255,255,.4)" fontFamily="system-ui">{s.sub}</text>
                {i < PIPELINE_STEPS.length - 1 && (
                  <line x1={x + 100} y1={36} x2={x + 116} y2={36} stroke="rgba(255,255,255,.15)" strokeWidth={1.2} markerEnd="url(#cib-arr)" />
                )}
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
}
